import bcrypt from 'bcryptjs';
import { useStoreState } from '@/stores/store';
import { useCallback, useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import PasswordGesture from '../';
import colors from '@/config/colors';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { useNotification } from '@/components/ui/therapist/Notification/NotificationProvider';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';

export default function CheckPassword() {
  const navigation = useNavigation();
  const [state, setState] = useState({
    message: 'Sperrmuster eingeben',
    status: 'normal',
  });
  const { PASSWORD } = useStoreState((store) => ({
    PASSWORD: store.appLockPattern,
  }));
  const { showNotification } = useNotification();
  const { setShowHeader } = useSidebarAnimation();
  const [unlocked, setUnlocked] = useState(false);

  useFocusEffect(
    useCallback(() => {
      return navigation.addListener('beforeRemove', (e) => {
        if (!unlocked) {
          e.preventDefault();
        } else {
          navigation.dispatch(e.data.action);
        }
      });
    }, [navigation, unlocked]),
  );

  function onEnd(password) {
    if (bcrypt.compareSync(password, PASSWORD)) {
      setUnlocked(true);

      // This timeout is necessary to trigger the navigation reset after the state update
      // without it, the navigation to the Home screen doesn't work on all devices.
      setTimeout(() => {
        navigation.reset({
          index: 0,
          routes: [{ name: 'Home' }],
        });
        setShowHeader(true);
      });
    } else {
      setUnlocked(false);
      setState({
        status: 'wrong',
        message: 'Sperrmuster ist falsch, versuchen Sie es erneut',
      });
    }
  }

  function onStart() {
    setState({
      status: 'normal',
      message: 'Sperrmuster eingeben',
    });
  }

  useFocusEffect(
    useCallback(() => {
      setShowHeader(false);
    }, []),
  );

  return (
    <>
      <View style={styles.container}>
        <View style={{ maxHeight: 360, flex: 1 }}>
          <PasswordGesture
            status={state.status}
            message={state.message}
            onStart={() => onStart()}
            onEnd={(password) => onEnd(password)}
            innerCircle={true}
            outerCircle={true}
            showNotification={showNotification}
          />
          <View style={styles.btnContainer}>
            <PressableNeolexon
              onPress={() => {
                navigation.navigate('PasswordUnlock');
                setShowHeader(false);
              }}
              style={styles.flexOne}
            >
              <Text style={styles.text}>Sperrmuster vergessen?</Text>
            </PressableNeolexon>
          </View>
        </View>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    backgroundColor: colors.black,
    paddingTop: Platform.OS === 'web' ? '12%' : 0,
  },
  btnContainer: {
    flexDirection: 'row',
    width: '100%',
    backgroundColor: colors.black,
    paddingBottom: 10,
  },
  flexOne: {
    flex: 1,
  },
  text: {
    textAlign: 'center',
    fontWeight: '700',
    paddingVertical: 10,
    fontSize: 16,
    color: colors.white,
  },
});
